import axios, { AxiosError } from "axios";
import { API_BASE_URL } from "config";
import apiClient from "config/apiClient";
import store from "store";
import { commonActions } from "store/common";

interface LoginResponse {
  access_token: string;
  refresh_token: string;
}

interface LoginErrorResponse {
  code?: string;
  message?: string;
}

export interface LoginResult {
  data?: LoginResponse;
  errorMessage?: string;
}

/**
 * @param email email
 * @param password password
 */
const loginApi = async (email: string, password: string): Promise<LoginResult> => {
  store.dispatch(commonActions.setLoading());
  try {
    const response = await axios.post<LoginResponse>(
      `${API_BASE_URL}/mst/user/auth/login`,
      { email_address: email, password },
      { timeout: 30000, headers: { "Content-Type": "application/json" } },
    );
    const { data } = response;
    if (data) {
      apiClient.setToken(data.access_token, data?.refresh_token);
    }
    return { data };
  } catch (err) {
    const axiosErr = err as AxiosError<LoginErrorResponse>;
    return {
      errorMessage: axiosErr.response?.data?.message || "ログインに失敗しました。",
    };
  } finally {
    store.dispatch(commonActions.removeLoading());
  }
};

export default loginApi;
